import gql from "graphql-tag";

export const ENSURE_INVOICE_REVIEW_SHORTLINK = gql`
  mutation ensureInvoiceReviewShortlink($invoiceId: ID!) {
    ensureInvoiceReviewShortlink(invoiceId: $invoiceId)
  }
`;
